/**
 * Character limits for device metadata fields
 * These limits are enforced both in the bulk edit UI and should match backend validation
 */
export const DEVICE_FIELD_LIMITS = {
  annotatedAssetId: 200,
  annotatedUser: 100,
  annotatedLocation: 200,
  notes: 500,
} as const;

export type DeviceFieldName = keyof typeof DEVICE_FIELD_LIMITS;

/**
 * Pattern matching invalid characters for Asset ID field
 * Characters < > | \ / are not allowed
 */
export const ASSET_ID_INVALID_CHARS_PATTERN = /[<>|/\\]/;

/**
 * Pattern for validating Asset ID - must NOT contain < > | \ /
 * Use this for validation: value.match(ASSET_ID_VALID_PATTERN)
 */
export const ASSET_ID_VALID_PATTERN = /^[^<>|/\\]*$/;

/**
 * Human-readable message for Asset ID pattern validation failure
 */
export const ASSET_ID_PATTERN_ERROR_MESSAGE = 'Asset ID cannot contain < > | \\ / characters';

/**
 * Human-readable message for character limit exceeded
 */
export const TEXT_LIMIT_EXCEEDED_ERROR_MESSAGE = 'Text limit exceeded: update your text';
